import SvgEditor from './SvgEditor';

export default SvgEditor;
